import React, { useState } from 'react';
import styles from '../../css/Contact/ContactForm.module.css';
import image from '../../assets/images/exp_card2_en_desktop-new-colors.webp';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaTelegram, FaTwitter, FaWhatsapp } from 'react-icons/fa6';

function ContactForm() {
	const [form, setForm] = useState({
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		message: '',
	});

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {
			const response = await fetch('http://localhost:5000/api/users', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					first_name: form.firstName,
					last_name: form.lastName,
					email: form.email,
					phone: form.phone,
					message: form.message,
				}),
			});

			if (response.ok) {
				const result = await response.json();
				alert('✅ Message sent successfully!');
				console.log(result);
				setForm({
					firstName: '',
					lastName: '',
					email: '',
					phone: '',
					message: '',
				});
			} else {
				alert('❌ Failed to send message.');
				console.error('Response error:', await response.text());
			}
		} catch (error) {
			console.error('❌ Error:', error);
			alert('❌ An error occurred while submitting the form.');
		}
	};

	return (
		<div className={styles.contactWrapper}>
			{/* Left Side Information */}
			<div className={styles.infoSide}>
				<div className={styles.brand}>
					<img src={image} alt="Token Logo" className={styles.logo} />
					<span>Exporest.</span>
				</div>
				<p className={styles.tagline}>
					Tether supports and empowers growing ventures and innovation as a
					digital token built on multiple blockchains.
				</p>
				<div className={styles.socials}>
					<Link>
						<FaTwitter className={styles.icon} />
					</Link>
					<Link>
						<FaTelegram className={styles.icon} />
					</Link>
					<Link>
						<FaLinkedin className={styles.icon} />
					</Link>
					<Link>
						<FaWhatsapp className={styles.icon} />
					</Link>
				</div>
			</div>
			{/* Right Side Form */}
			<div className={styles.formSide}>
				<h2 className={styles.formTitle}>GET IN TOUCH</h2>
				<div className={styles.formSubtitle}>
					24/7 We will answer your questions and problems
				</div>
				<form onSubmit={handleSubmit} className={styles.form}>
					<div className={styles.rowFlex}>
						<input
							type="text"
							name="firstName"
							placeholder="First Name"
							className={styles.halfWidth}
							value={form.firstName}
							onChange={handleChange}
							required
						/>
						<input
							type="text"
							name="lastName"
							placeholder="Last Name"
							className={styles.halfWidth}
							value={form.lastName}
							onChange={handleChange}
							required
						/>
					</div>
					<input
						type="email"
						name="email"
						placeholder="Email"
						value={form.email}
						onChange={handleChange}
						required
						className={styles.fullWidth}
					/>
					<input
						type="tel"
						name="phone"
						placeholder="Phone"
						value={form.phone}
						onChange={handleChange}
						className={styles.fullWidth}
					/>
					<textarea
						name="message"
						placeholder="Describe your issue"
						value={form.message}
						onChange={handleChange}
						required
						className={styles.fullWidth}
						rows={4}
					/>
					<button type="submit" className={styles.submitBtn}>
						Send
					</button>
				</form>
			</div>
		</div>
	);
}

export default ContactForm;
